import { render, staticRenderFns } from "./PortfolioForm.vue?vue&type=template&id=0b577d9c&scoped=true&"
import script from "./PortfolioForm.vue?vue&type=script&lang=js&"
export * from "./PortfolioForm.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioForm.vue?vue&type=style&index=0&id=0b577d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b577d9c",
  null
  
)

export default component.exports